import { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllAmbulanceMappings, editAmbulanceMappings } from "../../redux/actions/ambulanceEmployeeMapping";
import { editAmbulanceGeoFencingApi } from "../../apis/ambulance";
import { Button, Switch } from "antd";
import { TeamOutlined } from "@ant-design/icons";
import CustomTable from "../../common/CustomTable";
import crewMembers from "./crewMembers";
import CustomModal from "../../common/CustomModal";
import CustomBadge from "../../common/CustomBadge";
import CustomPopConfirm from "../../common/CustomPopConfirm";
import AssignCrewMembers from "./assignCrewMembers";
import AmbulanceFilter from "./ambulanceFilters";

function AllAmbulances() {
  const dispatch = useDispatch();
  const [pagination, setPagination] = useState({
    pageNo: 1,
    pageSize: 10,
    total: 0,
  });
  const [info, setInfo] = useState({})
  const [selectedAmbulance, setSelectedAmbulance] = useState(null);
  const [existingMembers, setExistingMembers] = useState([]);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [filters, setFilters] = useState({
    sortBy: "id",
    sortDirection: "ASC"
  })

  const { object = [], totalCount = 0, isProcessing: isLoading } = useSelector(
    (state) => state.ambulanceEmployeeMapping.data
  );

  useEffect(() => {
    setPagination((prev) => ({ ...prev, total: totalCount }));
  }, [totalCount]);

  useEffect(() => {
    dispatch(getAllAmbulanceMappings({ pageNo: pagination.pageNo -1, pageSize: pagination.pageSize, ...filters }));
  }, [dispatch, pagination.pageNo, pagination.pageSize, filters]);

  const handlePageChange = (pageNo) => {
    setPagination((prev) => ({ ...prev, pageNo }));
  };
  
  const handlePageSizeChange = (size) => {
    setPagination({ pageNo: 1, pageSize: size, total: pagination.total });
  };

  const handleSave = (query) => {
    dispatch(editAmbulanceMappings(query, selectedAmbulance.ambulance.id))
  };
  const handleUpdateClick = (record) => {
    setSelectedAmbulance(record);
    setExistingMembers(record?.employee || []);
    setIsModalVisible(true);
  };
  
  const columns = useMemo(() => [
    {
      title: "Ambulance Number",
      dataIndex: ["ambulance", "registrationNumber"],
      align: "center"
    },
    {
      title: "Type",
      dataIndex: ["ambulance", "type", "name"],
      align: "center"
    },
    {
      title: "Status",
      dataIndex: ["ambulance", "status", "name"],
      align: "center"
    },
   {
      title: "District",
      dataIndex: ["ambulance", "district", "name"],
      align: "center"
    },
    {
      title: "Contact No.",
      dataIndex: ["ambulance", "contactNo1"],
      align: "center"
    },
    {
      title: "Geo-Fencing",
      key: "geoFencingEnabled",
      align: "center",
      render: (_, record) => {
        
        return (
          <Switch
            checked={record.geofencingEnabled}
            onChange={(checked) =>
              handleGeoFencingToggle(record, checked, editAmbulanceGeoFencingApi)
            }
          />
        );
      }
    },    
    {
      title: "Crew Members",
      key: "crewMembers",
      align: "center",
      render: (_, record) => {
        const employees = Array.isArray(record?.employee)
          ? record.employee.filter(emp => emp && typeof emp === "object" && emp.employeeName)
          : [];
    
        return (
          <CustomPopConfirm 
            title="Crew Members"
            content={
              <>
                {employees.length > 0 ? (
                  crewMembers(employees)
                ) : (
                  <p>No crew members assigned</p>
                )}
                {employees.length < 6 && (
                  <Button type="link" onClick={() => handleUpdateClick(record)}>
                    Add Members
                  </Button>
                )}
              </>
            }
            okText="Ok"
            showCancel={false}
            triggerElement={
              <CustomBadge
                status={
                  employees.length === 3
                    ? "success"
                    : employees.length > 0
                    ? "warning"
                    : "error"
                }
                icon={
                  <TeamOutlined
                    style={{ fontSize: "18px", color: "#1890ff", cursor: "pointer" }}
                  />
                }
              />
            }
          />
        );
      }
    }
  ], []);
  const handleGeoFencingToggle = async (record, checked, editAmbulanceGeoFencingApi) => {
    try {
      await editAmbulanceGeoFencingApi(record?.ambulance.id,
        { isGeofencingEnabled: checked });
        dispatch(getAllAmbulanceMappings({
          pageNo: pagination.pageNo - 1,
          pageSize: pagination.pageSize,
          ...filters
        }));
    } catch (error) {
      console.log("Failed to update geofencing status");
    }
  };
  return (
    <div>
      <h1>All Ambulances List</h1>
      <AmbulanceFilter
        onFilter={(filters) => {
          setPagination((prev) => ({ ...prev, pageNo: 1 }));
          setFilters(filters);
        }}
      />
      {isLoading ? <p>Loading...</p> : null}
      {object?.length > 0 ? (
        <CustomTable
          columns={columns}
          data={object}
          loading={isLoading}
          pagination={pagination}
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
        />
      ) : (
        <p>No Ambulances Found</p>
      )}

      {isModalVisible && (
        <CustomModal
          visible={isModalVisible}
          onClose={() => setIsModalVisible(false)}
          title="Edit Crew Member"
          content={
            <div>
              <AssignCrewMembers
                selectedAmbulanceDetails={selectedAmbulance}
                initialEmployees={existingMembers}
                onSubmit={(queryString) => {
                  handleSave(queryString);
                }}
                errorMsg={info.errorMsg}
                successMsg={info.successMsg}
              />
            </div>
          }

          isEditable={false}
        />
      )}
    </div>
  );
}

export default AllAmbulances;
